import { render } from "./CardRow.vue?vue&type=template&id=c20cf11e&scoped=true"
import script from "./CardRow.vue?vue&type=script&lang=js"
export * from "./CardRow.vue?vue&type=script&lang=js"

import "./CardRow.vue?vue&type=style&index=0&id=c20cf11e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c20cf11e"]])

export default __exports__